import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavbarService } from './../../navbar/navbar.service';
import { NotificationRouteService } from '../../../shared-service/notification-route.service';
import { BaseService } from '../../../shared-service/base.service';
import { WindowRef } from '../../../shared-service/windowRef.service';

declare var $: any;

@Component({
  selector: 'item-notification',
  templateUrl: './item-notification.component.html',
  styleUrls: ['./item-notification.component.css']
})
export class ItemNotificationComponent implements OnInit {

  private storageResourcesKey: PropertyKey = 'StringResources';
  private storageNotificationDetailsKey: PropertyKey = 'NotificationDetailsKey';
  private params: Object|any = {};
  private stringResources: Object|any = {};
  public NotificationDetail: Object|any = {};
  public NotificationItems: Array<object> = [];
  public TodayNotificationItems: Array<any> = [];
  public YesterdayNotificationItems: Array<any> = [];
  public OldNotificationItems: Array<any> = [];

  public NotificationOrderByList: Array<any> = [];
  public NotificationOrderBy: string;



  constructor(public bs:BaseService, private router: Router, private navbarService: NavbarService, private notificationRouteService: NotificationRouteService ,private winRef: WindowRef) {
    this.bs.log('info',"Loaded NotificationComponent");
    this.stringResources = JSON.parse(this.navbarService.getStoreData(this.storageResourcesKey));
    this.NotificationOrderBy = this.stringResources['rbkey_RcntLBL_App'];
    this.NotificationOrderByList = [
      {
        action: "RECENT",
        name: this.stringResources['rbkey_RcntLBL_App']//this.stringResources['rbkey_RcntLBL_App']
      },
      {
        action: "READ",
        name: this.stringResources['rbkey_RdLBL']//this.stringResources['rbkey_RcntLBL_App']
      },
      {
        action: "UNREAD",
        name: this.stringResources['rbkey_UnrdLBL']//this.stringResources['rbkey_AnnncmntTtlLBL']
      }
    ]
  };

  ngOnInit() {
    this.bs.log('info',"ngOnInit NotificationComponent");
    this.params = {
      'OrderBy': "RECENT",
    };
   

    this.navbarService.setObservableValue({ "EnableNotification": false });
    this.navbarService.currentValue.subscribe(
        (result:any) => {
          this.getList();
        });

  };

  orderBy(OrderBy:any) {
    this.bs.log('info',OrderBy);
    let action = OrderBy.action;
    this.params['OrderBy'] = action;
    this.params['NotificationIds'] = null;
    this.params['PageNumber'] = 1;
    this.params['PageSize'] = 10;
    this.getList();
    return false;
  };

  getList() {
    this.navbarService.getNotificatiionListFromServer(this.params, this.storageNotificationDetailsKey).then((data:any) => {
      this.NotificationDetail = data;
      this.NotificationItems = this.NotificationDetail['NotificationItems'];
      this.updateLists(this.NotificationItems);
      this.bs.UnreadNotificationCount = this.NotificationDetail['TotalUnreadRecords'];
    }, (data) => {
      this.bs.log('error','Error in getting list');
    });
  };

  updateLists(nList: Array<object>|any) {
    this.TodayNotificationItems = [];
    this.YesterdayNotificationItems = [];
    this.OldNotificationItems = [];
    let noOfNoti = nList.length;
    if (noOfNoti == 0) {

      return;
    }
    for (let i = 0; i < noOfNoti; i++) {
      let nDate = nList[i]['ReceiveDate'];
      nDate = nDate.slice(0, 10);
      let days = this.dateDiffInDays(new Date(), new Date(nDate));
      if (days == 0) {
        this.TodayNotificationItems.push(nList[i]);
      } else if (days == 1) {

        this.YesterdayNotificationItems.push(nList[i]);
      } else {
        this.OldNotificationItems.push(nList[i]);
      }
    }
  }

dateDiffInDays(a:any, b:any) {
    let utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    let utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
    return Math.floor((utc2 - utc1) / (1000 * 60 * 60 * 24));
}


  updateNotification(NotificationId: any, Status: number, DayType: string) {
    this.params = {
      'NotificationIds': NotificationId,
      'Status': Status

    };
    this.navbarService.setNotificationStatusToServer(this.params, this.storageNotificationDetailsKey).then((data:any) => {
      if (data == "R") {
        this.bs.notificationCount = this.bs.notificationCount - 1;
        this.NotificationDetail['TotalUnreadRecords'] = this.NotificationDetail['TotalUnreadRecords'] - 1;
        $("#notificationDiv" + NotificationId).addClass("active");
        let unreadCount = parseInt(this.NotificationDetail['TotalUnreadRecords']);
        this.bs.UnreadNotificationCount = unreadCount;
      }
      if (data == "D") {
        // if(this.bs.notificationCount != 0){
        // this.bs.notificationCount = this.bs.notificationCount - 1;
        // this.NotificationDetail['TotalUnreadRecords'] = this.NotificationDetail['TotalUnreadRecords'] - 1;
        // }
        if (DayType == "TODAY") {
          this.TodayNotificationItems = this.TodayNotificationItems.filter(function (obj:any) {
            return obj['NotificationId'] !== NotificationId;
          });
        }
        if (DayType == "YEST") {
          this.YesterdayNotificationItems = this.YesterdayNotificationItems.filter(function (obj:any) {
            return obj['NotificationId'] !== NotificationId;
          });
        }
        if (DayType == "OLD") {
          this.OldNotificationItems = this.OldNotificationItems.filter(function (obj:any) {
            return obj['NotificationId'] !== NotificationId;
          });
        }
      }
    },
      (data) => {
        this.bs.log('error','Error in getting list');
      });
  }


  todayDate() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var today1;
    var dd1 = String(today.getDate());
    var mm1 = String(today.getMonth() + 1);
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd1 = '0' + dd;
    }
    if (mm < 10) {
      mm1 = '0' + mm;
    }
    today1 = dd1 + '/' + mm1 + '/' + yyyy;
    return today1;
  }
  setTodayClassName(index: any) {
    if (this.TodayNotificationItems[index]['IsRead']) {
      return "announcement-tab-list-box active";
    }
    else {
      return "announcement-tab-list-box";
    }
  }

  setOldClassName(index: any) {
    if (this.OldNotificationItems[index]['IsRead']) {
      return "announcement-tab-list-box active";
    }
    else {
      return "announcement-tab-list-box";
    }
  }

  setYesterdayClassName(index: any) {
    if (this.YesterdayNotificationItems[index]['IsRead']) {
      return "announcement-tab-list-box active";
    }
    else {
      return "announcement-tab-list-box";
    }
  }

  navigateListPage() {
    let bodyTag = $('body');
    bodyTag.removeClass('offsidebar-open');
    this.winRef.nativeWindow.document.getElementById('MenuName').style.visibility = "visible";
    this.winRef.nativeWindow.document.getElementById('MenuName').className="coll-left-arrow switch learning-la" ;
    this.winRef.nativeWindow.document.getElementById("headerMenuText").innerHTML = this.bs.getResource('rbkey_SystmNtfctnLBL');
    this.router.navigate(['/learner/system-alert/announcement', { IsAnnouncement: false, RefreshParam : new Date }]);
  }

  routeNotificationItem(Notification: Object|any) {
    let paramObj = {
      ItemType: Notification['ItemType'],
      ItemId: Notification['ItemId'],
      ActionName: Notification['ActionName']
    }
    this.notificationRouteService.routeNotificationItems(paramObj);
  }
}

